import axiosInstance from "../axios/instance";

export const getPublisherCategories = async (token, publisher_id) => {
  const url = new URL(
    process.env.REACT_APP_HUB_URL + "/api/publisher-categories/all"
  );
    url.searchParams.append('publisher_id', publisher_id)
    url.searchParams.append('token', token)
    const response = await axiosInstance.get(url.toString())
    return response?.data
};
